export default {
  Title: "Roles and permissions",
  NoRoleFound: 'No roles or permissions found.',
  RoleDetail: {},
  RoleList: { AddNew: "Add new", AddRole: "Add role" },
AddRoleTitle: "Add role and permissions",
EditRoleTitle: "Edit role and permissions",
};
